import { render, staticRenderFns } from "./BankDocumentPreview.vue?vue&type=template&id=5b6405c6&scoped=true&"
import script from "./BankDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./BankDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./BankDocumentPreview.vue?vue&type=style&index=0&id=5b6405c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6405c6",
  null
  
)

export default component.exports